import { getPhaserGameSync } from '../../../PhaserGame';
import type Game from '../../../scenes/Game';
import { getConferenceMediaTier, type ConferenceMediaTier } from '../../../config/mediaConfig';

/**
 * The talk-size tier right now, from the game's roster, with the occupant count it was derived from.
 * Read on demand rather than kept in React state: callers run inside LiveKit event handlers and timers.
 */
export function currentConferenceMediaTier(): { tier: ConferenceMediaTier; vrOccupantCount: number } {
  const game = getPhaserGameSync()?.scene?.keys?.game as Game | undefined;
  const vrOccupantCount = game?.network?.getLocalVirtualRoomOccupantCount?.() ?? 0;
  const officePlayerCount = game?.network?.room?.state?.players?.size ?? 0;
  return { tier: getConferenceMediaTier(vrOccupantCount, officePlayerCount), vrOccupantCount };
}
